import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { IPostcardUnlock, UnlockType } from '../IPlayerState';
import { setCoins } from '../PlayerInventoryHelper';

export function unlockPostcard(
    state: IGameState,
    postcardID: string
): IGameState {
    if (
        state.playerState.playerUnlocks.some(
            (unlock: IPostcardUnlock) =>
                unlock.type === UnlockType.POSTCARD && unlock.id === postcardID
        )
    ) {
        return state;
    }

    const playerState = setCoins(
        state.playerState,
        state.playerState.coins + 50
    );

    trackTransaction(state, TransactionType.REWARD, TActionType.SOCIAL);

    return {
        ...state,
        playerState: {
            ...playerState,
            playerUnlocks: [
                ...state.playerState.playerUnlocks,
                {
                    type: UnlockType.POSTCARD,
                    id: postcardID,
                },
            ],
        },
    };
}
